import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class DonationCallRequestService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetDonationCallRequest():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationCallRequest/Get`);
  }

  DeleteDonationCallRequest(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationCallRequest/Delete?id=${id}`);
  }

  CreateDonationCallRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationCallRequest/Create`,data);
  }
  UpdateDonationCallRequest(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationCallRequest/Update`,data)
  }
}
